module.exports = __webpack_public_path__ + "media/images/default/pay_services/2_md-6973985f2e3a0448ef4071d4a2b884a4.jpg";